var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52525 2.5H4.91923C3.57268 2.5 2.5 3.57268 2.5 4.91923V8.54807C2.5 9.8718 3.57268 10.9445 4.91923 10.9445H8.54807C9.8718 10.9445 10.9445 9.8718 10.9445 8.52525V4.91923C10.9445 3.57268 9.8718 2.5 8.52525 2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3636 10.9446H18.9925C20.3162 10.9446 21.3889 9.87191 21.3889 8.52534V4.91927C21.3889 3.57269 20.3163 2.5 18.9697 2.5H15.3636C14.017 2.5 12.9443 3.57269 12.9443 4.91927V8.54816C12.9443 9.87191 14.017 10.9446 15.3636 10.9446Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53481 13.0422H4.92307C3.57438 13.0422 2.5 14.1166 2.5 15.4653V19.0999C2.5 20.4257 3.57438 21.5001 4.92307 21.5001H8.55767C9.8835 21.5001 10.9579 20.4257 10.9579 19.077V15.4653C10.9579 14.1166 9.8835 13.0422 8.53481 13.0422Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1869 21.5001C19.5225 21.5001 21.4159 19.6067 21.4159 17.2711C21.4159 14.9355 19.5225 13.0422 17.1869 13.0422C14.8514 13.0422 12.958 14.9355 12.958 17.2711C12.958 19.6067 14.8514 21.5001 17.1869 21.5001Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.944c6657e97d5c9ad555b88ad2c10c85.svg";
export { ForwardRef as ReactComponent };